export default "__VITE_ASSET__B9zSB66A__"